import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { NgModel } from '@angular/forms/src/directives/ng_model';

@Component({
  selector: 'validation-message',
  template: `<div *ngIf="errorMessage !== null" class="error">{{errorMessage}}</div>`,
  styleUrls: ['./validation-message.component.css']
})
export class ValidationMessageComponent implements ControlValueAccessor {
  @Input() control: FormControl;
  onChange: any = () => { };
  onTouched: any = () => { };

  constructor() {
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(value) {
  }

  get errorMessage() {
    if (this.control == undefined) {
      //console.log("FOOBAR ValidationMessageComponent" + this + "and control:" + this.control);
    }
    else {
      for (let propertyName in this.control.errors) {
        if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
          return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
        }
      }
      return null;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/components/validation-message/validation-message.component.ts